import React from 'react';
import styled from 'styled-components';
import { Page } from '/imports/ui/Page';
import { NotPermittedPage } from '/imports/ui/NotPermittedPage';
import { useUser } from '/imports/hooks';
import { css } from '/imports/ui/css';
import { DevToolPullApns } from '/imports/ui/DevToolPullApns';
import { DevToolReonomyReset } from '/imports/ui/DevToolReonomyReset';
import { DevToolFormatAddresses } from '/imports/ui/DevToolFormatAddresses';
import { DevToolEtb } from '/imports/ui/DevToolEtb';
import { DevToolComstockGeo } from '/imports/ui/DevToolComstockGeo';
import { DevToolIntervalData } from '/imports/ui/DevToolIntervalData';
import { DevToolRicImport } from '/imports/ui/DevToolRicImport';
import { DevToolResTpoImport } from '/imports/ui/DevToolResTpoImport';
import { DevToolFundModelImport } from '/imports/ui/DevToolFundModelImport';
import { DevToolRemintFileTokens } from '/imports/ui/DevToolRemintFileTokens';
import { DevToolAdoptPmDocuments } from '/imports/ui/DevToolAdoptPmDocuments';
import { DevToolFomwareProbe } from '/imports/ui/DevToolFomwareProbe';
import { DevToolQuickbooks } from '/imports/ui/DevToolQuickbooks';
import { DevToolQuickbooksApi } from '/imports/ui/DevToolQuickbooksApi';
import { DevToolQuickbooksCashSync } from '/imports/ui/DevToolQuickbooksCashSync';
import { DevToolQuickbooksOutflowSync } from '/imports/ui/DevToolQuickbooksOutflowSync';

const DevToolsPageStyled = styled(Page)`
  padding: 0 3rem;
  padding-top: 1.5rem;
  box-sizing: border-box;
  section {
    padding: 1rem;
    margin-bottom: 1rem;
    border: ${css.border};
    border-radius: ${css.borderRadius};
  }
`;

/**
 * Dev Tools admin page aggregating the individual developer tool panels.
 */
export const DevToolsPage = () => {
  const user = useUser();
  if (user && !user.isSuperUser) return <NotPermittedPage />;
  return (
    <DevToolsPageStyled>
      <h1>Dev Tools</h1>
      <DevToolPullApns />
      <DevToolReonomyReset />
      <DevToolFormatAddresses />
      <DevToolEtb />
      <DevToolComstockGeo />
      <DevToolIntervalData />
      <DevToolRicImport />
      <DevToolResTpoImport />
      <DevToolFundModelImport />
      <DevToolQuickbooks />
      <DevToolQuickbooksApi />
      <DevToolQuickbooksCashSync />
      <DevToolQuickbooksOutflowSync />
      <DevToolRemintFileTokens />
      <DevToolAdoptPmDocuments />
      <DevToolFomwareProbe />
    </DevToolsPageStyled>
  );
};

